<template>
  <div class="row">
    <div class="col-12">
      <card>
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="filter">
            <filter-component
              :isRequiredFarms="true"
              :isRequiredLots="false"
              :onlyFarmsFruits="true"
              @filter="handleFilter"
              @showHideLoading="showHideLoading"
              classFarms="col-12 col-sm-6 col-md-6 col-lg-4"
              classLots="col-12 col-sm-6 col-md-6 col-lg-4"
            >
              <template slot="after-lot">
                <div class="col-12 col-md-4 pt-3">
                  <div class="form-group has-label">
                    <label for=""
                      >{{ $t('common_words.report_typeof') }}:
                    </label>
                    <el-select
                      class="select-primary mb-3 shadow-sm required-type"
                      v-model="reportType"
                      @clear="tableData = []"
                      @change="tableData = []"
                      :placeholder="`${$t('common_words.select2')}...`"
                    >
                      <el-option
                        class="select-primary"
                        v-for="item in [
                          { id: 0, value: $t('common_words.detailed') },
                          { id: 1, value: $t('common_words.consolidated') },
                        ]"
                        :key="item.id + item.value"
                        :label="item.value"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </template>
            </filter-component>
          </el-collapse-item>
        </el-collapse>
      </card>
      <card
        v-if="tableData.farms && tableData.farms.length > 0 && reportType === 0"
      >
        <el-collapse
          class="custom-el-collapse my-4"
          v-model="farmActiveName"
          accordion
          @change="loadData"
        >
          <el-collapse-item
            class="custom-collapse-item collapse-data"
            v-for="farm in Object.values(tableData.farms)"
            :name="`${farm.id}`"
            :key="farm.id"
          >
            <template slot="title">
              <div class="d-flex align-items-center justify-content-start">
                <span style="text-transform: capitalize">
                  <strong>Finca: </strong>
                  {{ farm.name }}
                </span>
              </div>
            </template>
            <div class="row my-4" v-if="seletedData.table">
              <div
                class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
              >
                <el-select
                  clearable
                  @clear="pagination.perPage = 10"
                  class="select-default mb-3 shadow-sm"
                  style="width: 200px"
                  v-model="pagination.perPage"
                  :placeholder="$t('common_words.per_page')"
                  filterable
                >
                  <el-option
                    class="select-default"
                    v-for="item in perPageOptions"
                    :key="item"
                    :label="item === 0 ? $t('common_words.see_all') : item"
                    :value="
                      item === 0 ? totalRegister(seletedData.table) : item
                    "
                  >
                  </el-option>
                </el-select>
                <el-input
                  clearable
                  show-word-limit
                  class="mb-3 shadow-sm"
                  style="width: 200px"
                  :placeholder="$t('common_words.search_records')"
                  v-model="searchQuery"
                  aria-controls="datatables"
                />
              </div>
              <div class="col-12">
                <div class="table-responsive" style="overflow-x: scroll">
                  <table class="table table-striped table-bordered">
                    <thead-profile-cluster />
                    <tbody-profile-cluster
                      :data="queriedDataRows(seletedData.table)"
                      :cellNames="cellNames"
                    />
                    <tfoot-profile-cluster
                      :totals="seletedData.totals"
                      :rows="queriedDataRows(seletedData.table)"
                      :numberPages="numberPages()"
                      :cellNames="cellNames"
                    />
                  </table>
                </div>
                <template ref="cardfooter">
                  <div
                    slot="footer"
                    class="mt-3 col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                  >
                    <div class>
                      <p class="card-category">
                        {{ $t('table2.showing') }} {{ from + 1 }}
                        {{ $t('table2.a') }}
                        {{ toRows(seletedData.table) }}
                        {{ $t('table2.of') }}
                        {{ totalRegister(seletedData.table) }}
                        {{ $t('table2.entries') }}
                      </p>
                    </div>
                    <l-pagination
                      class="pagination-no-border"
                      v-model="pagination.currentPage"
                      :per-page="pagination.perPage"
                      :total="pagination.total"
                      pageFirst="false"
                      pageLast="false"
                    ></l-pagination>
                  </div>
                </template>
                <export-tables
                  :pdf="{
                    filename: `${$t('production.cluster_fruit_profile')}.pdf`,
                    route: 'summary/profilecluster/pdf',
                    paramMethod: 'POST',
                    plusData: { ...getDataToExport },
                  }"
                  :xls="{
                    filename: `${$t('production.cluster_fruit_profile')}.xlsx`,
                    route: 'summary/profilecluster/excel',
                    paramMethod: 'POST',
                    plusData: { ...getDataToExport },
                  }"
                />
              </div>
              <div class="col-12 mt-5">
                <card
                  class="custom-shadow-card-header"
                  :title="$t('production.net_weight_distribution')"
                  v-if="showNetWeightChart"
                >
                  <span>
                    <div class="row">
                      <div class="col-12">
                        <highcharts :options="chartOptions[0]"></highcharts>
                      </div>
                    </div>
                  </span>
                </card>
              </div>
              <div class="col-12 mt-5">
                <card
                  class="custom-shadow-card-header"
                  :title="$t('production.defect_average_wastage')"
                  v-if="showDefectChart"
                >
                  <span>
                    <div class="row">
                      <div class="col-12">
                        <highcharts :options="chartOptions[1]"></highcharts>
                      </div>
                    </div>
                  </span>
                </card>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
        <div class="col-12 my-5">
          <export-tables
            :pdf="{
              filename: `${$t('production.cluster_fruit_profile')}.pdf`,
              route: 'summary/profilecluster/pdf',
              paramMethod: 'POST',
              plusData: { ...exportAll },
            }"
            :xls="{
              filename: `${$t('production.cluster_fruit_profile')}.xlsx`,
              route: 'summary/profilecluster/excel',
              paramMethod: 'POST',
              plusData: { ...exportAll },
            }"
            :labelExportPDF="$t('common_words.export_all_to_pdf')"
            :labelExportExcel="$t('common_words.export_all_to_excel')"
          />
        </div>
      </card>
      <card v-if="reportType === 1 && tableData.consolidated">
        <div class="row mt-4">
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-select
              clearable
              @clear="pagination.perPage = 10"
              class="select-default mb-3 shadow-sm"
              style="width: 200px"
              v-model="pagination.perPage"
              :placeholder="$t('common_words.per_page')"
              filterable
            >
              <el-option
                class="select-default"
                v-for="item in perPageOptions"
                :key="item"
                :label="item === 0 ? $t('common_words.see_all') : item"
                :value="
                  item === 0
                    ? totalRegister(tableData.consolidated.data, 'farm')
                    : item
                "
              >
              </el-option>
            </el-select>
            <el-input
              clearable
              show-word-limit
              class="mb-3 shadow-sm"
              style="width: 200px"
              :placeholder="$t('common_words.search_records')"
              v-model="searchQuery"
              aria-controls="datatables"
            />
          </div>
          <div class="col-12">
            <div class="table-responsive" style="overflow-x: scroll">
              <table class="table table-striped table-bordered">
                <thead-consolidated />
                <tbody-consolidated
                  :dataConsolidated="
                    queriedDataRows(tableData.consolidated.data, 'farm')
                  "
                />
                <tfoot-profile-cluster
                  :totals="tableData.consolidated.totals"
                  :rows="queriedDataRows(tableData.consolidated.data, 'farm')"
                  :numberPages="numberPages()"
                  :cellNames="cellNames"
                  :reportType="reportType"
                />
              </table>
            </div>
            <template ref="cardfooter">
              <div
                slot="footer"
                class="mt-3 col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
              >
                <div class>
                  <p class="card-category">
                    {{ $t('table2.showing') }} {{ from + 1 }}
                    {{ $t('table2.a') }}
                    {{ toRows(tableData.consolidated.data, 'farm') }}
                    {{ $t('table2.of') }}
                    {{ totalRegister(tableData.consolidated.data, 'farm') }}
                    {{ $t('table2.entries') }}
                  </p>
                </div>
                <l-pagination
                  class="pagination-no-border"
                  v-model="pagination.currentPage"
                  :per-page="pagination.perPage"
                  :total="pagination.total"
                  pageFirst="false"
                  pageLast="false"
                ></l-pagination>
              </div>
            </template>
            <div class="col-12 mb-5">
              <export-tables
                :pdf="{
                  filename: `${$t('production.cluster_fruit_profile')}.pdf`,
                  route: 'summary/profilecluster/consolidated/pdf',
                  paramMethod: 'POST',
                  plusData: { ...exportAll },
                }"
                :xls="{
                  filename: `${$t('production.cluster_fruit_profile')}.xlsx`,
                  route: 'summary/profilecluster/consolidated/excel',
                  paramMethod: 'POST',
                  plusData: { ...exportAll },
                }"
              />
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { Chart } from 'highcharts-vue';
import { MixinExport } from 'src/mixins/mixin-export';
import { Pagination as LPagination } from 'src/components/index';
import AbbreviatedTextTooltip from 'src/components/Texts/AbbreviatedTextTooltip.vue';
import Filter from 'src/components/Filter/Filters.vue';
import MixinCharts from 'src/util/mixinCharts';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import PaginationTable from './Pagination';
import SweetAlert from 'src/class/Alerts';
import TbodyProfileCluster from './TbodyProfileCluster.vue';
import TfootProfileCluster from './TfootProfileCluster.vue';
import TheadProfileCluster from './TheadProfileCluster.vue';
import TheadConsolidated from './TheadConsolidated.vue';
import TbodyConsolidated from './TbodyConsolidated.vue';
import i18n from 'src/i18n';

export default {
  components: {
    [AbbreviatedTextTooltip.name]: AbbreviatedTextTooltip,
    [Filter.name]: Filter,
    [TheadProfileCluster.name]: TheadProfileCluster,
    [TfootProfileCluster.name]: TfootProfileCluster,
    [TbodyProfileCluster.name]: TbodyProfileCluster,
    [TheadConsolidated.name]: TheadConsolidated,
    [TbodyConsolidated.name]: TbodyConsolidated,
    LPagination,
    highcharts: Chart,
  },

  data() {
    return {
      reportType: 0,
      activeName: 'filter',
      farmActiveName: '0',
      valueCollapse: null,
      dataFilter: [],
      seletedData: {},
      chartOptions: [{}, {}],
      farms: null,
      perPageOptions: [5, 10, 25, 50, 0],
      openCollapse: false,
      cellNames: {
        edge: 1,
        net_weight_avg: 1,
        net_weight_max: 2,
        net_weight_min: 3,
        stem_weight_avg: 1,
        hands_number_avg: 1,
        hands_number_max: 2,
        hands_number_min: 3,
        gauge_second_hand_avg: 1,
        gauge_last_hand_avg: 1,
        length_second_hand_avg: 1,
        length_last_hand_avg: 1,
        length_last_hand_max: 2,
        length_last_hand_min: 3,
        fingers_number: 1,
        merma: 1,
        ratio: 1,
      },
    };
  },
  mixins: [mixinMasters, MixinMenu, MixinExport, MixinCharts, MixinPermissions],
  computed: {
    getDataToExport() {
      const response = { ...this.dataFilter };
      delete response.route;
      this.$set(response, 'farm', [this.farmActiveName]);

      return response;
    },

    exportAll() {
      const response = { ...this.dataFilter };
      delete response.route;

      return response;
    },

    showNetWeightChart() {
      if (
        Number(this.farmActiveName) !== 0 &&
        this.tableData.netWeightChart[this.farmActiveName] &&
        this.tableData.netWeightChart[this.farmActiveName].values[0] &&
        this.tableData.netWeightChart[this.farmActiveName].values[0].data &&
        this.tableData.netWeightChart[this.farmActiveName].values[0].data
          .length > 0
      ) {
        return true;
      }
      return false;
    },

    showDefectChart() {
      if (
        Number(this.farmActiveName) !== 0 &&
        this.tableData.defectChart[this.farmActiveName] &&
        this.tableData.defectChart[this.farmActiveName].series[0] &&
        this.tableData.defectChart[this.farmActiveName].series[0].data &&
        this.tableData.defectChart[this.farmActiveName].series[0].data.length >
          0
      ) {
        return true;
      }
      return false;
    },
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
  },
  methods: {
    ...PaginationTable.methods,

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    numberPages() {
      if (this.reportType == 0) {
        if (this.seletedData.table) {
          const result = Number(
            this.totalRegister(this.seletedData.table) / this.pagination.perPage
          );
          return result <= 0 ? 1 : Math.round(result);
        }
      } else {
        if (this.tableData.consolidated.data) {
          const result = Number(
            this.totalRegister(this.tableData.consolidated.data, 'farm') /
              this.pagination.perPage
          );
          return result <= 0 ? 1 : Math.round(result);
        }
      }

      return 1;
    },

    loadData() {
      if (this.reportType == 0) {
        this.openCollapse = !this.openCollapse;
        if (this.farmActiveName && this.farmActiveName !== '') {
          this.seletedData = {
            table: this.tableData.table[this.farmActiveName],
            totals: this.tableData.totals[this.farmActiveName],
          };

          this.$set(
            this.chartOptions,
            0,
            this.pieChart(
              this.tableData.netWeightChart[this.farmActiveName],
              2,
              true,
              null,
              true
            )
          );

          this.$set(
            this.chartOptions,
            1,
            this.columns(this.tableData.defectChart[this.farmActiveName], true)
          );

          try {
            this.searchFuse(
              ['name'],
              this.getRows(this.seletedData.table),
              0.2
            );
          } catch (error) {
            console.log(error);
          }
          this.pagination.perPage = 10;
          this.searchQuery = '';
        } else {
          this.seletedData = {};
        }
      } else {
        try {
          this.searchFuse(
            ['name'],
            this.getRows(this.tableData.consolidated.data, 'farm'),
            0.2
          );
        } catch (error) {
          console.log(error);
        }
      }

      this.pagination.perPage = 10;
      this.searchQuery = '';
    },

    handleFilter(data) {
      if (this.reportType === null || ![0, 1].includes(Number(this.reportType)))
        return this.validationInputsRequired('type');
      else {
        this.seletedData = {};
        this.generalAVG = 0;
        this.tableData = [];
        this.farmActiveName = '';
        this.dataFilter = { ...data, reportType: this.reportType };
        this.getDataProfileClusterReport();
      }
    },

    getDataProfileClusterReport() {
      this.showHideLoading(true);
      let data = this.dataFilter;
      data.route = 'summary/profilecluster';
      Axios.postMasters(data)
        .then((response) => {
          this.tableData = response.data.data;

          if (this.tableData.farms && this.tableData.farms.length == 0) {
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
          } else {
            if (!this.openCollapse && this.reportType == 0) {
              setTimeout(() => {
                document
                  .getElementsByClassName('collapse-data')[0]
                  .getElementsByClassName('el-collapse-item__header')[0]
                  .click();
                this.openCollapse = true;
              }, 50);
            } else {
              this.farmActiveName = `${this.dataFilter.farm[0]}`;
              this.loadData();
            }
          }
        })
        .catch((error) => {
          this.showMessageErrors(error);
        })
        .finally(() => {
          this.showHideLoading();
        });
    },

    exportToPDF() {
      let data = {};
      data.name_file = `${i18n.t('production.cluster_fruit_report')}.pdf`;
      data = { ...data, ...this.dataFilter };
      data.route = 'summary/profilecluster/pdf';

      this.PDF(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },

    exportToExcel() {
      let data = {};
      data.name_file = `${i18n.t('production.cluster_fruit_report')}.xlsx`;
      data = { ...data, ...this.dataFilter };
      data.route = 'summary/profilecluster/excel/';

      this.Excel(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },
  },

  mounted() {
    this.selectedItemOnMenu('summary');
  },

  beforeDestroy() {
    this.deselectedItemOnMenu('summary');
  },
};
</script>
